import _ from 'lodash'
import store from '@/store/index'
import { getKey } from '@/api/common/request'
import { CommentActionTypes } from '@/modules/tenantProjects/submissions/consts'
import dateUtil from './dateUtil'
import i18n from './i18n'

export function buildNewSection (payload) {
  const userId = _.get(store.getters['user/currentUser'], 'id', null)
  const date = new Date()
  return {
    createdAt: date,
    updatedAt: date,
    updatedBy: userId,
    createdBy: userId,
    value: '',
    displayOrder: '',
    order: 0,
    status: 'DRAFT',
    version: 0,
    sectionContent: [{
      order: 0,
      value: '',
    }],
    ...payload,
  }
}

export async function createCustomSection (originSection) {
  const id = await getKey()
  const itemId = await getKey()
  let result = buildNewSection({
    id,
    itemId,
    status: 'PUBLISHED',
    sectionContent: [],
    order: originSection.order,
    secondaryOrder: originSection.secondaryOrder + 1,
  })
  return result
}

export function updateSectionSecondaryOrder (comments, { originSection, originIndex }) {
  return comments.reduce((rs, item, index) => {
    if (item.order === originSection.order) {
      item.secondaryOrder = index
    }
    rs.push(item)
    return rs
  }, [])
}

export function isGuideLineSection (section) {
  return section.secondaryOrder === 0
}

export function buildLastActionText (record) {
  if (!record) return
  const typeKeyMap = {
    [CommentActionTypes.CHECK]: 'selectedBy',
    [CommentActionTypes.ADD]: 'addedBy',
    [CommentActionTypes.UPDATE]: 'lastUpdatedBy',
  }
  const date = dateUtil.format(record.updatedAt, 'DD MMM YY HH:mm')
  return i18n.t(typeKeyMap[record.actionType], [record.user.displayName, date])
}

export function sortTechComments (comments = []) {
  return _.orderBy(comments, ['order', 'secondaryOrder'], ['asc', 'asc'])
}
